var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", [
      _c("input", {
        ref: "ziplocation",
        staticClass:
          "FormTextbox__Input zipCodeIdentifierSpacer zipcodeIdentiferBlock",
        attrs: {
          type: "text",
          name: _vm.elementName,
          id: _vm.guidId,
          "aria-describedby": _vm.ariaDescribedBy,
          placeholder: _vm.placeHolder,
          maxlength: "5"
        },
        on: {
          focus: _vm.handleFocus,
          blur: _vm.handleBlur,
          keydown: function($event) {
            if (
              !$event.type.indexOf("key") &&
              _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
            ) {
              return null
            }
            $event.preventDefault()
            return _vm.submitByEnter($event)
          },
          keypress: _vm.validateNumber
        }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loadingLocations,
            expression: "loadingLocations"
          }
        ],
        staticClass: "loading-message"
      },
      [_vm._v("Loading locations...")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "location-dropdown-list" }, [
      _vm.loadedLocations
        ? _c(
            "div",
            {
              staticClass:
                "location-referrer-container zipCodeIdentifierSpacer",
              attrs: { id: "location-referrer" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "Form__Element FormSelection",
                  attrs: {
                    "data-f-element-name": "__field_locationselect",
                    data_f_type: "selection"
                  }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "Form__Element__Caption",
                      attrs: { for: "GUID-SOMETHING" }
                    },
                    [
                      _vm._v(
                        "\n          If applicable, select the Simmons Bank branch that referred you to this form.\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      key: _vm.locationData.id,
                      staticClass: "form-control location-list",
                      attrs: { "aria-label": "location select" },
                      on: { change: _vm.getAdvisorsByLocation }
                    },
                    [
                      _c("option"),
                      _vm._v(" "),
                      _vm._l(_vm.locationData, function(location) {
                        return _c(
                          "option",
                          {
                            attrs: { name: location.id },
                            domProps: { value: location.locationCode }
                          },
                          [
                            _vm._v(
                              _vm._s(location.address.addressLine1) +
                                ", " +
                                _vm._s(location.address.city) +
                                ", " +
                                _vm._s(location.address.state) +
                                ", " +
                                _vm._s(location.address.zip)
                            )
                          ]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        : _c("div")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "loading-message"
      },
      [_vm._v("Loading advisors...")]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "advisor-dropdown-list" }, [
      _vm.loaded
        ? _c(
            "div",
            {
              staticClass: "advisor-referrer-container zipCodeIdentifierSpacer",
              attrs: { id: "advisor-referrer" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "Form__Element FormSelection",
                  attrs: {
                    "data-f-element-name": "__field_advisorselect",
                    data_f_type: "selection"
                  }
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "Form__Element__Caption",
                      attrs: { for: "GUID-SOMETHING" }
                    },
                    [
                      _vm._v(
                        "\n          If applicable, select the Simmons Bank representative that referred you to this form.\n        "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      key: _vm.advisorData.id,
                      staticClass: "form-control advisor-list",
                      attrs: { "aria-label": "advisor select" },
                      on: { change: _vm.updateAdvisorHiddenValue }
                    },
                    [
                      _c("option"),
                      _vm._v(" "),
                      _vm._l(_vm.advisorData, function(advisor) {
                        return _c(
                          "option",
                          {
                            attrs: { name: advisor.id },
                            domProps: { value: advisor.name }
                          },
                          [_vm._v(_vm._s(advisor.name))]
                        )
                      })
                    ],
                    2
                  )
                ]
              )
            ]
          )
        : _c("div")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }